import _ from 'lodash';

class StoreTimeout {
  listTimerId: ReturnType<typeof setTimeout>[];

  store: Record<string, ReturnType<typeof setTimeout>[]>;

  constructor() {
    this.listTimerId = [];
    this.store = {};
  }

  createStore = (key: string) => {
    this.store[key] = [];
  };

  removeStore = (key: string, timerId: ReturnType<typeof setTimeout>) => {
    if (key in this.store && _.isArray(this.store?.[key])) {
      _.remove(this.store?.[key], (id) => {
        if (id === timerId) {
          clearTimeout(id);
          return true;
        }
        return false;
      });
    }
  };

  destroyStore = (key: string) => {
    if (key in this.store) {
      delete this.store?.[key];
    }
  };

  cancelStore = (key: string) => {
    if (key in this.store && _.isArray(this.store[key])) {
      _.forEach(this.store[key], (id) => clearTimeout(id));
      this.store[key] = [];
    }
  };

  resetStore = () => {
    this.store = {};
  };

  cancelAllStore = () => {
    Object.keys(this.store).forEach((key) => {
      _.forEach(this.store[key], (id) => clearTimeout(id));
    });
    this.resetStore();
  };

  pushStore = (key: string, timerId: ReturnType<typeof setTimeout>) => {
    if (!(key in this.store)) {
      this.createStore(key);
    }
    if (key in this.store && !_.includes(this.store?.[key], timerId)) {
      this.store[key].push(timerId);
    }
  };

  addTimer = (timerId: ReturnType<typeof setTimeout>) => {
    this.listTimerId.push(timerId);
  };

  removeTimer = (timerId: ReturnType<typeof setTimeout>) => {
    _.remove(this.listTimerId, (id) => id === timerId);
  };

  clearAllTimer = () => {
    _.forEach(this.listTimerId, (id) => clearTimeout(id));
    this.listTimerId = [];
  };
}

export const storeTimeout = new StoreTimeout();
